import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deletePackageSaga,
  getPackageDetailsSaga,
  getPackageListSaga,
} from "src/store/web-packages/saga";
import { PackageDetailDto, PackageDto } from "src/store/web-packages/type";
import PackageCreateForm from "./create";
import PackageEditForm from "./edit";
const PackagePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<PackageDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<PackageDetailDto>();
  const columns = [
    {
      text: t("Package.Name"),
      dataField: "Name",
    },
    {
      text: t("Para Birimi"),
      dataField: "CurrencyCode",
    },
    {
      text: t("Aylık Fiyat"),
      dataField: "ListPriceMonthly",
      formatter: (c: number, d: PackageDetailDto) => (
        <>
          <span style={{ textDecoration: "line-through" }}>
            {d.ListPriceMonthly}{" "}
          </span>
          / <span style={{ fontWeight: "bold" }}>{d.CampaignPriceMonthly}</span>
        </>
      ),
    },

    {
      text: t("Yıllık Fiyat"),
      dataField: "ListPriceYearly",
      formatter: (c: number, d: PackageDetailDto) => (
        <>
          <span style={{ textDecoration: "line-through" }}>
            {d.ListPriceYearly}{" "}
          </span>
          / <span style={{ fontWeight: "bold" }}>{d.CampaignPriceYearly}</span>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Package.PageTitle")}
        metaTag={t("Package.MetaTag")}
        gridProps={{
          addTitle: t("Package.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getPackageListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getPackageDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            condition(keyValue, data) {
              return keyValue !== "aa67b0c4-9ccd-42b0-b302-595a7caab787";
            },
            text: (id, data: PackageDto) =>
              t("Package.DeleteQA", {
                name: data.Name,
              }),
            action: deletePackageSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <PackageCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getPackageListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <PackageEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getPackageListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default PackagePage;
